import api from "apis"

const processOrder = async (values, path) => {
  const response = await api.post(`/secure/api/v10/order/${path}`, values)

  if (response.errors?.length) {
    throw new Error(response.errors?.[0])
  }

  return response
}

export default processOrder
